import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/superstitions.pdf'; 
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
		Opera Omnia volume IV/2<br />
		Ludovic Dutens (ed)<br />
		pp 278-279<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: 1690 (?)<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (92k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Observation of Certain Superstitions of the Slavs</title>
            <meta name="description" content="An English translation of OBSERVATION OF CERTAIN SUPERSTITIONS OF THE SLAVS by Gottfried Wilhelm Leibniz, from 1690 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: OBSERVATION OF CERTAIN SUPERSTITIONS OF THE SLAVS</h2>
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br />
                 [<b>Dutens IV 2, p278</b>]<br /><br />		
                The Sarmatian rites that survive in medieval Slavs present as it were an image of the Germans' old way of living, just as we see in the Abyssinians nowadays the ancient church of the fifth century, as in a mirror. For the Slavs, having been converted to Christ quite late, have preserved the most ancient customs for a long time. In book 2 chapter 32 of the <var>Life of Otto von Bamberg</var>, who converted the Pomeranians to Christianity while accompanied on the expedition by <var>Sefrid</var>, [<b>Dutens IV 2, p279</b>] who wrote the book, we may observe two superstitions which throw light on similar ones noticed by Tacitus in the Germans.<a name="1" href="#note1"><sup>1</sup></a> These are the auguries of horses and the lots of dry wood. The Pomeranians had a black horse of remarkable size which was plump and very spirited. It did not work the whole year, was so holy that no one was permitted to ride it, and had one of the four priests of the temples as a most diligent guardian. Now, when the people were thinking about a land assault against enemies or about going pillaging, they were accustomed to learn the result through the horse in the following way. Nine spears were laid out on the ground, one cubit apart. Then, with the horse saddled and bridled, the priest, to whom the protection of the horse was entrusted, held it by the bridle and led it through the spears lying crosswise and then led it back again three times. If the horse passed without damaging its hooves or disturbing the spears, the people took it as a sign of success and they proceeded without fear. Finally, he (Otto), with God's help, did away with this kind of decision by lot along with other <var>divinations by dry wood</var> in which they observed omens of a naval battle or pillage, although this was greeted with uproar by some. And as he feared that the horse of profane prophecy might be a snare or cause of stumbling to the simple folk, he ordered that it be sold in a foreign land, asserting that it was more suited to chariots than prophecies. In the next chapter the author observes that many wives were forbidden.<a name="2" href="#note2"><sup>2</sup></a> In this, evidently the Sarmatians differed from the Germans.<a name="3" href="#note3"><sup>3</sup></a>


                        <br /><br /><br />
                        <hr className='rightcol-hr' />
                        <br /><br />NOTES:<br /><br />
                        <a name="note1" href="#1">1.</a> See Ebo and Herbordus, <var>The Life of Otto Apostle of Pomerania 1060-1139</var>, trans. Charles H. Robinson (London: The Macmillan Company, 1920), 79-80.<br />
                        <a name="note2" href="#2">2.</a> Ibid, 81.<br />
                        <a name="note3" href="#3">3.</a> Leibniz's point seems to be that the Germans never did practice polygamy, whereas the Sarmatians did until it was forbidden.
                <br /><br /><br />
                        &#169; Lloyd Strickland 2018
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
